import React from "react";
import HeroSection from "../component/HeroSection";
import AchievementsStrip from "../component/AchievementsStrip";
import AboutSection from "../component/AboutSection";
import ServicesSection from "../component/ServicesSection";
import WhyChooseUs from "../component/WhyChooseUs";
import TestimonialsSection from "../component/TestimonialsSection";
import CtaSection from "../component/CtaSection";
import ContactBar from "../component/ContactBar";
import SocialStrip from "../component/SocialStrip";
import "../styles/Homepage.css";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import Marquee from "../component/Marquee";

const Homepage = () => {
  return (
    <div className="homepage">
        <Navbar/>
        <Marquee variant="default" />
      {/* Hero Section */}
      <HeroSection />
      
      {/* Achievements Strip */}
      <AchievementsStrip />
      
      {/* About Section */}
      <AboutSection />
      
      {/* Services Section */}
      <Marquee variant="services" />
      <ServicesSection />
      
      {/* Why Choose Us Section */}
      <WhyChooseUs />
      
      {/* Testimonials Section */}
      <TestimonialsSection />
      <Marquee variant="achievementItems" />
      {/* CTA Section */}
      <CtaSection />
      
      {/* Contact Bar */}
      <ContactBar />
      
      {/* Social Strip */}
      <SocialStrip />
      <Footer/>
    </div>
  );
};

export default Homepage;